import LogoWhite from "../assets/images/Logo_White.png";
import LogoGray from "../assets/images/Logo_Gray.png";

const Images = {
  LogoWhite,
  LogoGray,
};

export default Images;
